import { useState } from "react";

function AvatarImg({ src, nome, size = 40 }) {
  const [erro, setErro] = useState(false);

  const inicial = nome?.charAt(0)?.toUpperCase() ?? "?";

  if (erro || !src) {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          background: "#ccc",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          fontSize: size * 0.5,
          color:"white"
        }}
      >
        {inicial}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={nome}
      onError={() => setErro(true)}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        objectFit: "cover",
      }}
    />
  );
}

export default AvatarImg;
